import { styles } from './themes/NavigationListSeparator.css';

/**
 * NavigationListSeparator is a component that renders a visual separator (displayed
 * as a horizontal line) between collections of items within NavigationList.
 *
 * @param {NavigationListSeparatorProps} props Component props for NavigationListSeparator.
 * @returns {JSX.Element} Component element for NavigationListSeparator.
 */
export function NavigationListSeparator() {
  return <div class={styles.separator} role="presentation" />;
}
